import { render, staticRenderFns } from "./MapVirtualTourPage.vue?vue&type=template&id=a068b166&scoped=true&"
import script from "./MapVirtualTourPage.vue?vue&type=script&lang=js&"
export * from "./MapVirtualTourPage.vue?vue&type=script&lang=js&"
import style0 from "./MapVirtualTourPage.vue?vue&type=style&index=0&id=a068b166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a068b166",
  null
  
)

export default component.exports